/** Trusted client names shown in homepage / industries marquee. */
export const TRUSTED_COMPANY_NAMES = [
  'M Financial',
  'Riverview Bank',
  'Eastern Energy Services',
  'iCreditWorks',
  'BHP Billiton',
  'BP',
  'Direct Energy',
  'Genesis Energy',
  'EY',
  'Conoco',
  'McDermott',
  'Whitney Bank',
  'LyondellBasell',
  'National Oilwell Varco',
  'Archrock',
  'Nabors Industries',
  'Innovex',
  'Baker Hughes',
  'Plains All-American Pipeline',
  'Reliant Energy',
  'Friedkin Companies',
  'Excelerate Energy',
  'McLane Trucking',
] as const;
